import { loginSuccess, setUserProp } from "../services/amplitude";

export const requestLoginSuccess = (resData) => {
  localStorage.setItem('token', resData.login.access_token);
  localStorage.setItem('id', resData.login.UserId);

  const role = resData.is_premium === true ? 'Premium' : 'Free';

  // amplitude
  loginSuccess(resData.id, 'email', role, resData.login.email, 'Login Page');
  setUserProp({
    email: resData.email,
    name: resData.first_name,
    is_User: 'True',
    is_Premium: resData && `${resData.subscription_status === '3' ? 'True' : 'False'}`,
  })
  // end of amplitude
}